/* eslint-disable max-len -- SVG path data is one long token per icon; wrapping it would corrupt it. */
// GENERATED from docs/design_handoff/recolearn/lib.jsx (const ICONS).
// Regenerating? Keep the eslint-disable line above, and re-merge LOCAL_ICON_PATHS below —
// regeneration only replaces BUNDLE_ICON_PATHS.
// Do not hand-edit: regenerate when the design bundle refreshes.
//
// Each value is the raw `d` attribute of a 24x24 stroke icon. A single <path> may carry
// several M subpaths, so the prototype's split-on-M is unnecessary here.

/** Path data for the 58 icons in the Recolearn design set. */
const BUNDLE_ICON_PATHS: Readonly<Record<string, string>> = {
  "award": "M12 15a7 7 0 100-14 7 7 0 000 14zM8.21 13.89L7 23l5-3 5 3-1.21-9.12",
  "bell": "M12 22a2 2 0 002-2H10a2 2 0 002 2zm6-6V11a6 6 0 10-12 0v5l-2 2v1h16v-1l-2-2z",
  "bolt": "M13 2L3 14h7l-1 8 10-12h-7l1-8z",
  "book": "M4 19.5A2.5 2.5 0 016.5 17H20M4 4.5A2.5 2.5 0 016.5 2H20v20H6.5a2.5 2.5 0 01-2.5-2.5z",
  "bot": "M12 8V4H8M16 8h2a2 2 0 012 2v6a2 2 0 01-2 2H6a2 2 0 01-2-2v-6a2 2 0 012-2h2M12 4h.01M9 13h.01M15 13h.01M8 18l-2 3M16 18l2 3",
  "branch": "M6 3v12M18 9a3 3 0 100-6 3 3 0 000 6zM6 21a3 3 0 100-6 3 3 0 000 6zM18 9v3a4 4 0 01-4 4H6",
  "building": "M3 21h18M9 8h1m4 0h1m-6 4h1m4 0h1m-6 4h1m4 0h1M5 21V5a2 2 0 012-2h10a2 2 0 012 2v16",
  "calendar": "M19 4H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2zM16 2v4M8 2v4M3 10h18",
  "cam": "M23 7l-7 5 7 5V7zM1 5h15v14H1z",
  "card": "M21 4H3a2 2 0 00-2 2v12a2 2 0 002 2h18a2 2 0 002-2V6a2 2 0 00-2-2zM1 10h22",
  "check": "M5 13l4 4L19 7",
  "chev-down": "M6 9l6 6 6-6",
  "chev-left": "M15 18l-6-6 6-6",
  "chev-right": "M9 18l6-6-6-6",
  "chev-up": "M18 15l-6-6-6 6",
  "clock": "M12 22a10 10 0 110-20 10 10 0 010 20zM12 6v6l4 2",
  "dollar": "M12 2v20M17 5H9.5a3.5 3.5 0 100 7h5a3.5 3.5 0 110 7H6",
  "download": "M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3",
  "drag": "M9 3v18M15 3v18",
  "edit": "M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7M18.5 2.5a2.12 2.12 0 113 3L12 15l-4 1 1-4 9.5-9.5z",
  "external": "M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6M15 3h6v6M10 14L21 3",
  "file": "M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z M14 2v6h6",
  "filter": "M3 6h18M6 12h12M10 18h4",
  "flag": "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1zM4 22V15",
  "flame": "M8.5 14.5A2.5 2.5 0 0011 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 11-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 002.5 2.5z",
  "globe": "M12 22a10 10 0 110-20 10 10 0 010 20zM2 12h20M12 2a15 15 0 010 20",
  "grid": "M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z",
  "inbox": "M22 12h-6l-2 3h-4l-2-3H2M5.45 5.11L2 12v6a2 2 0 002 2h16a2 2 0 002-2v-6l-3.45-6.89A2 2 0 0016.76 4H7.24a2 2 0 00-1.79 1.11z",
  "layers": "M12 2l10 6-10 6L2 8l10-6zM2 16l10 6 10-6M2 12l10 6 10-6",
  "layout": "M3 3h18v18H3z M3 9h18 M9 21V9",
  "link": "M10 13a5 5 0 007.07 0l3-3a5 5 0 00-7.07-7.07l-1.72 1.71M14 11a5 5 0 00-7.07 0l-3 3a5 5 0 007.07 7.07l1.72-1.71",
  "list": "M3 6h18M3 12h18M3 18h18",
  "lock": "M19 11H5a2 2 0 00-2 2v7a2 2 0 002 2h14a2 2 0 002-2v-7a2 2 0 00-2-2zM7 11V7a5 5 0 0110 0v4",
  "message": "M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z",
  "mic": "M12 2a3 3 0 00-3 3v6a3 3 0 006 0V5a3 3 0 00-3-3zM5 11a7 7 0 0014 0M12 19v3M8 22h8",
  "more": "M5 12h.01M12 12h.01M19 12h.01",
  "paperclip": "M21 11l-9.5 9.5a5.5 5.5 0 11-7.78-7.78L13 4.5a3.5 3.5 0 014.95 4.95L8.5 18.9a1.5 1.5 0 11-2.12-2.12L15 8.5",
  "pause": "M6 5h4v14H6zM14 5h4v14h-4z",
  "pin": "M12 17v5M9 3h6l1 6 3 3H5l3-3 1-6z",
  "pkg": "M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16zM3.27 6.96L12 12.01l8.73-5.05M12 22.08V12",
  "play": "M6 4l14 8-14 8z",
  "plus": "M12 5v14M5 12h14",
  "rupee": "M6 3h12M6 8h12M14 14L6 14M14 21L6 14",
  "search": "M11 19a8 8 0 100-16 8 8 0 000 16zm10 2l-4.35-4.35",
  "send": "M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z",
  "settings": "M12 15a3 3 0 100-6 3 3 0 000 6zM19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 11-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 11-4 0v-.09a1.65 1.65 0 00-1-1.51 1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 11-2.83-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 110-4h.09a1.65 1.65 0 001.51-1 1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 112.83-2.83l.06.06a1.65 1.65 0 001.82.33h0a1.65 1.65 0 001-1.51V3a2 2 0 114 0v.09a1.65 1.65 0 001 1.51h0a1.65 1.65 0 001.82-.33l.06-.06a2 2 0 112.83 2.83l-.06.06a1.65 1.65 0 00-.33 1.82v0a1.65 1.65 0 001.51 1H21a2 2 0 110 4h-.09a1.65 1.65 0 00-1.51 1z",
  "shield": "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z",
  "sparkle": "M12 3l1.9 5.8L20 11l-6.1 1.9L12 19l-1.9-6.1L4 11l6.1-2.2L12 3z",
  "star": "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z",
  "trash": "M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2M10 11v6M14 11v6",
  "upload": "M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12",
  "user": "M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M12 11a4 4 0 100-8 4 4 0 000 8z",
  "users": "M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75",
  "video": "M23 7l-7 5 7 5V7zM1 5h15v14H1z",
  "voice": "M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7zM12 8v8m-3-6v4m6-4v4",
  "wand": "M15 4V2M15 16v-2M8 9h2M20 9h2M17.8 11.8l1.4 1.4M17.8 6.2l1.4-1.4M3 21l9-9M12.2 6.2l-1.4-1.4",
  "x": "M18 6L6 18M6 6l12 12",
  "zap": "M13 2L3 14h7l-1 8 10-12h-7l1-8z"
};


const LOCAL_ICON_PATHS: Readonly<Record<string, string>> = {
  // Expand/collapse for a docked panel that opens into a full-screen workspace.
  "expand": "M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7",
  "collapse": "M4 14h6v6M20 10h-6V4M14 10l7-7M3 21l7-7",
  "alert": "M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0zM12 9v4M12 17h.01",
  // Rail group glyphs the bundle has no equivalent for.
  "home": "M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2zM9 22V12h6v10",
  "phone": "M17 2H7a2 2 0 00-2 2v16a2 2 0 002 2h10a2 2 0 002-2V4a2 2 0 00-2-2zM12 18h.01",
  "briefcase": "M20 7H4a2 2 0 00-2 2v9a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2zM16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16",
  "wallet": "M21 12V7H5a2 2 0 010-4h14v4M3 5v14a2 2 0 002 2h16v-5M18 12a2 2 0 000 4h4v-4z",
  "cloud": "M18 10h-1.26A8 8 0 109 20h9a5 5 0 000-10z",
  // Correction, not a new glyph: the bundle draws `more` as three zero-length strokes, which the
  // 1.8 stroke width renders as hairline specks all but invisible at the 16px a row menu uses.
  // The same three dots in the same places, as filled discs — a circle whose radius is half the
  // stroke width has no hole left in it.
  "more": "M4.1 12a0.9 0.9 0 1 0 1.8 0 0.9 0.9 0 1 0 -1.8 0M11.1 12a0.9 0.9 0 1 0 1.8 0 0.9 0.9 0 1 0 -1.8 0M18.1 12a0.9 0.9 0 1 0 1.8 0 0.9 0.9 0 1 0 -1.8 0",
  // Undo arrow for bringing an archived row back. No bundle glyph turns a destructive step around.
  "restore": "M3 12a9 9 0 109-9 9.75 9.75 0 00-6.74 2.74L3 8 M3 3v5h5",
  // Correction, not a new glyph: the bundle's triangle spans y4-20 where the rest of the set
  // spans y3-21, so it rendered a fifth shorter than its neighbours in the rail.
  "play": "M5 3l14 9-14 9z",
  // Show/hide on a password field. The bundle's auth screens have no reveal toggle to draw one for.
  "eye": "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8zM12 15a3 3 0 100-6 3 3 0 000 6z",
  "eye-off": "M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24M1 1l22 22",
  // A test hint. The runner prototype draws it with `sparkle`, but that glyph means AI and these
  // hints are written by the instructor, so it gets a plain one.
  "bulb": "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 006 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5M9 18h6M10 22h4",
  // Dead-end states reached by following a link: expired share link, meeting without a passcode,
  // unreachable video, server down. Each "-off" is its base glyph struck through.
  "link-off": "M10 13a5 5 0 007.07 0l3-3a5 5 0 00-7.07-7.07l-1.72 1.71M14 11a5 5 0 00-7.07 0l-3 3a5 5 0 007.07 7.07l1.72-1.71M1 1l22 22",
  "video-off": "M16 16v1a2 2 0 01-2 2H3a2 2 0 01-2-2V7a2 2 0 012-2h2m5.66 0H14a2 2 0 012 2v3.34l1 1L23 7v10M1 1l22 22",
  "cloud-off": "M22.61 16.95A5 5 0 0018 10h-1.26a8 8 0 00-7.05-6M5 5a8 8 0 004 15h9a5 5 0 001.7-.3M1 1l22 22",
  "key": "M21 2l-2 2m-7.61 7.61a5.5 5.5 0 11-7.778 7.778 5.5 5.5 0 017.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4",
  // Assignment kinds on the learner worklist, where the prototype draws ⌨ for a coding lab and
  // ☑ for a quiz. `check` alone is taken: it marks work that has been graded.
  "keyboard": "M20 5H4a2 2 0 00-2 2v10a2 2 0 002 2h16a2 2 0 002-2V7a2 2 0 00-2-2zM5.5 9.5h1M9.5 9.5h1M13.5 9.5h1M17.5 9.5h1M8 14.5h8",
  "check-square": "M9 11l3 3L22 4M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11",
  // Page-level back beside a workspace title. `chev-left` steps within a pager; this leaves the page.
  "arrow-left": "M19 12H5M12 19l-7-7 7-7",
  // Work in progress: a screen held back while it is refined (ui/planned/in-progress-screen).
  "tool": "M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"
};

export const DESIGN_ICON_PATHS: Readonly<Record<string, string>> = {
  ...BUNDLE_ICON_PATHS,
  ...LOCAL_ICON_PATHS
};

export type DesignIconName = keyof typeof DESIGN_ICON_PATHS;

/** Namespace used when registering with MatIconRegistry: <mat-icon svgIcon="rl:sparkle">. */
export const DESIGN_ICON_NAMESPACE = "rl";
